import { buildInfoSchema, type BuildInfo } from '@rollcall/contracts'

/**
 * Версия и сборка клиента (D19).
 *
 * Значения подставляются на сборке из одного источника — корневого
 * `package.json` и переменной окружения с хешем (см. vite.config.ts).
 * В коде клиента числа версии нет.
 */
export function appBuildInfo(): BuildInfo {
  return buildInfoSchema.parse({
    version: import.meta.env.VITE_APP_VERSION,
    commit: import.meta.env.VITE_APP_COMMIT,
  })
}
